var map = {
	"./_.png": "./src/EGRContent/Story/RamailoMela/images/_.png",
	"./balloon01.png": "./src/EGRContent/Story/RamailoMela/images/balloon01.png",
	"./balloon_green.png": "./src/EGRContent/Story/RamailoMela/images/balloon_green.png",
	"./bg_2.jpg": "./src/EGRContent/Story/RamailoMela/images/bg_2.jpg",
	"./bg_9_and_10_flag.png": "./src/EGRContent/Story/RamailoMela/images/bg_9_and_10_flag.png",
	"./bg_9_and_10_front.png": "./src/EGRContent/Story/RamailoMela/images/bg_9_and_10_front.png",
	"./bg_9_and_10_sky.jpg": "./src/EGRContent/Story/RamailoMela/images/bg_9_and_10_sky.jpg",
	"./bg_carpenter_didi.jpg": "./src/EGRContent/Story/RamailoMela/images/bg_carpenter_didi.jpg",
	"./bg_painter_didi.jpg": "./src/EGRContent/Story/RamailoMela/images/bg_painter_didi.jpg",
	"./bg_painter_didi_new.jpg": "./src/EGRContent/Story/RamailoMela/images/bg_painter_didi_new.jpg",
	"./carpenter_didi.gif": "./src/EGRContent/Story/RamailoMela/images/carpenter_didi.gif",
	"./carpenter_didi.png": "./src/EGRContent/Story/RamailoMela/images/carpenter_didi.png",
	"./cobbler_dai.png": "./src/EGRContent/Story/RamailoMela/images/cobbler_dai.png",
	"./cover-page.jpg": "./src/EGRContent/Story/RamailoMela/images/cover-page.jpg",
	"./cover-page2.png": "./src/EGRContent/Story/RamailoMela/images/cover-page2.png",
	"./dai4.png": "./src/EGRContent/Story/RamailoMela/images/dai4.png",
	"./didi_playing_baja.gif": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja.gif",
	"./didi_playing_baja.png": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja.png",
	"./didi_playing_baja01.png": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja01.png",
	"./didi_playing_baja_body.gif": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja_body.gif",
	"./didi_playing_baja_eye.gif": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja_eye.gif",
	"./didi_playing_baja_eye.png": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja_eye.png",
	"./didi_playing_baja_head.png": "./src/EGRContent/Story/RamailoMela/images/didi_playing_baja_head.png",
	"./flag.gif": "./src/EGRContent/Story/RamailoMela/images/flag.gif",
	"./heading.png": "./src/EGRContent/Story/RamailoMela/images/heading.png",
	"./heading01.png": "./src/EGRContent/Story/RamailoMela/images/heading01.png",
	"./leaf01.png": "./src/EGRContent/Story/RamailoMela/images/leaf01.png",
	"./leaf02.png": "./src/EGRContent/Story/RamailoMela/images/leaf02.png",
	"./leaf03.png": "./src/EGRContent/Story/RamailoMela/images/leaf03.png",
	"./nima-flower.png": "./src/EGRContent/Story/RamailoMela/images/nima-flower.png",
	"./nima-hands-up.png": "./src/EGRContent/Story/RamailoMela/images/nima-hands-up.png",
	"./nima-look.png": "./src/EGRContent/Story/RamailoMela/images/nima-look.png",
	"./nima-look2.png": "./src/EGRContent/Story/RamailoMela/images/nima-look2.png",
	"./nima-play.png": "./src/EGRContent/Story/RamailoMela/images/nima-play.png",
	"./nima-walk.png": "./src/EGRContent/Story/RamailoMela/images/nima-walk.png",
	"./nima-walk2.png": "./src/EGRContent/Story/RamailoMela/images/nima-walk2.png",
	"./nima-wave01.png": "./src/EGRContent/Story/RamailoMela/images/nima-wave01.png",
	"./nima-with-mum.gif": "./src/EGRContent/Story/RamailoMela/images/nima-with-mum.gif",
	"./nima-with-mum.png": "./src/EGRContent/Story/RamailoMela/images/nima-with-mum.png",
	"./nima01.gif": "./src/EGRContent/Story/RamailoMela/images/nima01.gif",
	"./nima6_new.png": "./src/EGRContent/Story/RamailoMela/images/nima6_new.png",
	"./nima8_bend.png": "./src/EGRContent/Story/RamailoMela/images/nima8_bend.png",
	"./nima8_bend_new.png": "./src/EGRContent/Story/RamailoMela/images/nima8_bend_new.png",
	"./nima9.png": "./src/EGRContent/Story/RamailoMela/images/nima9.png",
	"./nima_hands-side.png": "./src/EGRContent/Story/RamailoMela/images/nima_hands-side.png",
	"./nima_moving_head.gif": "./src/EGRContent/Story/RamailoMela/images/nima_moving_head.gif",
	"./nima_moving_head_body.png": "./src/EGRContent/Story/RamailoMela/images/nima_moving_head_body.png",
	"./nima_moving_head_head.png": "./src/EGRContent/Story/RamailoMela/images/nima_moving_head_head.png",
	"./nima_play_jhali.png": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali.png",
	"./nima_play_jhali3.gif": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali3.gif",
	"./nima_play_jhali_body01.gif": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali_body01.gif",
	"./nima_play_jhali_body01.png": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali_body01.png",
	"./nima_play_jhali_head01.gif": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali_head01.gif",
	"./nima_play_jhali_head01.png": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali_head01.png",
	"./nima_play_jhali_talking.gif": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali_talking.gif",
	"./nima_play_jhali_talking.png": "./src/EGRContent/Story/RamailoMela/images/nima_play_jhali_talking.png",
	"./nima_shoe_look.png": "./src/EGRContent/Story/RamailoMela/images/nima_shoe_look.png",
	"./nima_talking_dai.gif": "./src/EGRContent/Story/RamailoMela/images/nima_talking_dai.gif",
	"./nima_talking_didi.gif": "./src/EGRContent/Story/RamailoMela/images/nima_talking_didi.gif",
	"./nima_talking_didi.png": "./src/EGRContent/Story/RamailoMela/images/nima_talking_didi.png",
	"./nima_talking_tailor_dai.gif": "./src/EGRContent/Story/RamailoMela/images/nima_talking_tailor_dai.gif",
	"./nima_talking_tailor_dai.png": "./src/EGRContent/Story/RamailoMela/images/nima_talking_tailor_dai.png",
	"./nima_walk.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walk.gif",
	"./nima_walk.png": "./src/EGRContent/Story/RamailoMela/images/nima_walk.png",
	"./nima_walk_from_flash.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walk_from_flash.gif",
	"./nima_walking_2.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_2.gif",
	"./nima_walking_2b.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_2b.gif",
	"./nima_walking_2ba.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_2ba.gif",
	"./nima_walking_2s.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_2s.gif",
	"./nima_walking_3.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_3.gif",
	"./nima_walking_3b.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_3b.gif",
	"./nima_walking_new11.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_new11.gif",
	"./nima_walking_new11b.gif": "./src/EGRContent/Story/RamailoMela/images/nima_walking_new11b.gif",
	"./nima_waving_hand.gif": "./src/EGRContent/Story/RamailoMela/images/nima_waving_hand.gif",
	"./nima_waving_hand.png": "./src/EGRContent/Story/RamailoMela/images/nima_waving_hand.png",
	"./nima_with_flower.png": "./src/EGRContent/Story/RamailoMela/images/nima_with_flower.png",
	"./page10.jpg": "./src/EGRContent/Story/RamailoMela/images/page10.jpg",
	"./page11_bg.png": "./src/EGRContent/Story/RamailoMela/images/page11_bg.png",
	"./page1_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page1_bg.jpg",
	"./page3_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page3_bg.jpg",
	"./page3_didi_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page3_didi_bg.jpg",
	"./page4_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page4_bg.jpg",
	"./page6_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page6_bg.jpg",
	"./page6_bg_tailor1.jpg": "./src/EGRContent/Story/RamailoMela/images/page6_bg_tailor1.jpg",
	"./page7_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page7_bg.jpg",
	"./page8_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page8_bg.jpg",
	"./page9_bg.jpg": "./src/EGRContent/Story/RamailoMela/images/page9_bg.jpg",
	"./ramaelomela.svg": "./src/EGRContent/Story/RamailoMela/images/ramaelomela.svg",
	"./ramaelomela_ra.svg": "./src/EGRContent/Story/RamailoMela/images/ramaelomela_ra.svg",
	"./ramaelomela_text.svg": "./src/EGRContent/Story/RamailoMela/images/ramaelomela_text.svg",
	"./rotaping.png": "./src/EGRContent/Story/RamailoMela/images/rotaping.png",
	"./sky.png": "./src/EGRContent/Story/RamailoMela/images/sky.png",
	"./smoke.png": "./src/EGRContent/Story/RamailoMela/images/smoke.png",
	"./smoke_leaves.png": "./src/EGRContent/Story/RamailoMela/images/smoke_leaves.png",
	"./standing_nima01.png": "./src/EGRContent/Story/RamailoMela/images/standing_nima01.png",
	"./swipping_dai_body.png": "./src/EGRContent/Story/RamailoMela/images/swipping_dai_body.png",
	"./swipping_dai_hand_broom.png": "./src/EGRContent/Story/RamailoMela/images/swipping_dai_hand_broom.png",
	"./swipping_dai_head.png": "./src/EGRContent/Story/RamailoMela/images/swipping_dai_head.png",
	"./swipping_dai_new.gif": "./src/EGRContent/Story/RamailoMela/images/swipping_dai_new.gif",
	"./tailor_dai (1).png": "./src/EGRContent/Story/RamailoMela/images/tailor_dai (1).png",
	"./tailor_dai.gif": "./src/EGRContent/Story/RamailoMela/images/tailor_dai.gif",
	"./tailor_dai.png": "./src/EGRContent/Story/RamailoMela/images/tailor_dai.png",
	"./tailor_dai_loop.gif": "./src/EGRContent/Story/RamailoMela/images/tailor_dai_loop.gif",
	"./thumnail (2).png": "./src/EGRContent/Story/RamailoMela/images/thumnail (2).png",
	"./thumnail.png": "./src/EGRContent/Story/RamailoMela/images/thumnail.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/RamailoMela/images sync recursive ^\\.\\/.*$";